import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sortingDown",
  "use": "sortingDown-usage",
  "viewBox": "0 0 8 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 8 5\" id=\"sortingDown\">\n<path d=\"M0.5,0.8C0.3,0.8,0.1,0.9,0,1.1C0,1.2,0,1.4,0.1,1.6c1.2,1.7,3.5,3.3,3.5,3.3S3.8,5,4,5c0.2,0,0.3-0.1,0.3-0.1\n\ts2.3-1.7,3.5-3.3C8,1.4,8,1.2,8,1.1C7.9,0.9,7.7,0.8,7.5,0.8H0.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol